'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALERT_TYPES = exports.ALERT_TYPES = {
  info: 'alert-info private-alert--info',
  warning: 'alert-warning private-alert--warning',
  success: 'alert-success private-alert--success',
  danger: 'alert-danger private-alert--danger',
  tip: 'private-alert--tip'
};

var ALERT_USES = exports.ALERT_USES = {
  default: '',
  inline: 'private-alert--inline'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/alert/AlertTypes.js
// module id = 289
// module chunks = 0